import { MailOutlined } from '@mui/icons-material'
import { Col, Menu, Row } from 'antd'
import React from 'react'
import MenuItem from '../Settings/MenuItem'
import PageLayout from '../Settings/PageLayout'

function Settings({user}) {
    var [activeItem, setActiveItem] = React.useState('profile')
    return (
        <Row gutter={[50 , 25]} style={{margin : 0}}>
            <Col span={6} xl={6} md={10} sm={24} xs={24} >
                <MenuItem activeItem={activeItem} setActiveItem={setActiveItem} />
            </Col>
            <Col span={18} xl={18} md={14} sm={24} xs={24} >
                <PageLayout user={user} activeItem={activeItem} />
            </Col>
        </Row>
    )
}

export default Settings
